// Identity of this physical device (Kasse, Bar-PC, Kellner-Handy).
// Printers always belong to a device; the device token lets this browser pick up
// its print jobs independent of which waiter is logged in.

const STORAGE_KEY = 'fiscalpos_device';
export const DEVICE_IDENTITY_EVENT = 'fiscalpos:device-identity';

export function readDeviceIdentity() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    if (parsed && parsed.id && parsed.token) {
      return { id: String(parsed.id), name: String(parsed.name || ''), token: String(parsed.token) };
    }
  } catch {
    // Storage blocked or corrupt: behave like an unregistered device.
  }
  return null;
}

function notifyIdentityChange() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(DEVICE_IDENTITY_EVENT));
  }
}

export function writeDeviceIdentity(identity) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      id: identity.id,
      name: identity.name || '',
      token: identity.token,
    }));
  } catch {
    // Without storage the device must be registered again after a reload.
  }
  notifyIdentityChange();
}

export function clearDeviceIdentity() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  notifyIdentityChange();
}

export function describePlatform() {
  if (typeof navigator === 'undefined') return 'Web';
  const userAgent = navigator.userAgent || '';
  const os = /Android/i.test(userAgent)
    ? 'Android'
    : /iPhone|iPad|iPod/i.test(userAgent)
      ? 'iOS'
      : /Mac OS X/i.test(userAgent)
        ? 'macOS'
        : /Windows/i.test(userAgent)
          ? 'Windows'
          : /Linux/i.test(userAgent)
            ? 'Linux'
            : 'Web';
  const browser = /Edg\//.test(userAgent)
    ? 'Edge'
    : /Chrome\//.test(userAgent)
      ? 'Chrome'
      : /Firefox\//.test(userAgent)
        ? 'Firefox'
        : /Safari\//.test(userAgent)
          ? 'Safari'
          : 'Browser';
  return `${os} · ${browser}`;
}
